(function () {

    'use strict';

    angular.module('iplusjs.validator.form', [
        'lodash',
        'iplusjs.utils.formField',
        'iplusjs.alert.service',
        'iplusjs.navigation',
        'iplusjs.utils.tracking'
    ])
        .directive('iplusjsFormValidator', formValidator);

    formValidator.$inject = [
        '$rootScope',
        '$window',
        '$timeout',
        'lodash',
        'FormFieldUtilsService',
        'AlertService',
        'NavigationService',
        'TrackingUtilsService'
    ];

    function formValidator($rootScope, $window, $timeout, _, FormFieldUtilsService, AlertService, NavigationService, TrackingUtilsService) {
        return {
            restrict: 'A',
            require: ['?form', '?ngForm'],
            link: function ($scope, $elem, $attrs, formCtrl) {
                var ctrl = formCtrl[0] || formCtrl[1];

                $elem.on('submit', function () {
                    $window.document.activeElement.blur();
                    $scope.$broadcast('form:submit');
                });

                $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                    if (ctrl && !ctrl.stateChangeCanceled) {
                        ctrl.submitInProgress = true;
                    }

                    if (!NavigationService.isNavigationStepEnabled(toState.name, fromState.name, ctrl, toParams)) {
                        if (ctrl) {
                            ctrl.submitInProgress = false;
                            FormFieldUtilsService.setControlsSubmitted(ctrl.$$controls);

                            if (ctrl.$invalid && !AlertService.hasAlerts()) {
                                $timeout(function () {
                                    FormFieldUtilsService.focusFirstInvalid($elem);
                                }, 0);
                            }
                        }
                    }
                });

                TrackingUtilsService.trackFormControls($scope, ctrl);

                $scope.$on('$stateChangeSuccess', function () {
                    if (ctrl) {
                        if (ctrl.submitInProgress) {
                            ctrl.submitInProgress = false;
                        }
                    }
                });

                $scope.$on('$stateChangeError', function () {
                    if (ctrl) {
                        if (ctrl.submitInProgress) {
                            ctrl.submitInProgress = false;
                        }
                    }
                });

                $scope.$watchCollection(function () {
                    return ctrl.$error;
                }, function (newValue, oldValue) {
                    if (!_.isEqual(newValue, oldValue)) {
                        $timeout(function () {
                            $rootScope.$emit('iplusjs:heightChanged');
                        }, 0);
                    }
                });

                $scope.$on('form:submit', function () {
                    ctrl.$commitViewValue();

                    if (ctrl.$submitted) {
                        ctrl.isSubmitted = true;

                        if (ctrl.$invalid && !AlertService.hasAlerts()) {
                            $timeout(function () {
                                FormFieldUtilsService.focusFirstInvalid($elem);
                            }, 0);
                        }
                    }

                    FormFieldUtilsService.setControlsSubmitted(ctrl.$$controls);

                    $timeout(function () {
                        $rootScope.$emit('iplusjs:heightChanged');
                    }, 0);
                });
            }
        };
    }
})();
